export enum TrnSkillGradeExpiracyStatus {
	NotExpired = 0,
	AlmostExpired = 1,
	Expired = 2,
	ExpirationPrediction = 3
}